import { gql } from '@edreamsodigeo/frontend-api-client';

export const ADD_BUYER_TO_SHOPPING_BASKET = gql`
  mutation AP_AddContactDetailsToShoppingBasket(
    $request: AddContactDetailsToShoppingBasketRequest
  ) {
    addContactDetailsToShoppingBasket(request: $request)
  }
`;
